<div class="container">
  <div class="container-inventory">
    <div class="header">
      <h1 class="title">{{ 'OUR_POLICIES' | translate }}</h1>
    </div>

    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="form-card">
      <app-terms-and-conditions></app-terms-and-conditions>
    </div>
    <div class="form-card">
      <app-privacy-policy></app-privacy-policy>
    </div>
    <div class="form-card">
      <app-online-policy></app-online-policy>
    </div>
  </div>
</div>
